import React from 'react';

const EmailSentIcon = ({ className }) => (
  <svg
    className={className}
    width='135'
    height='91'
    viewBox='0 0 135 91'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path d='M135 20.8545V82.6291L86.2164 54.855L80.7524 51.7434L135 20.8545Z' fill='url(#paint0_linear_87_339)' />
    <path
      d='M54.2571 51.7434L48.7931 54.855L0.00634766 82.6291V20.8545L54.2571 51.7434Z'
      fill='url(#paint1_linear_87_339)'
    />
    <path
      d='M135 82.6289V85.893C135 87.2076 134.478 88.4684 133.548 89.398C132.619 90.3276 131.358 90.8498 130.043 90.8498H4.95676C3.64214 90.8498 2.38138 90.3276 1.4518 89.398C0.522226 88.4684 0 87.2076 0 85.893V82.6289L48.7868 54.8548L54.2508 51.7432L63.4113 56.9582C63.8808 57.2267 64.376 57.4477 64.8893 57.6179C65.0605 57.6739 65.2285 57.7237 65.4028 57.7703C66.7766 58.1313 68.2203 58.1313 69.5941 57.7703C69.7652 57.7237 69.9364 57.6739 70.1075 57.6179C70.6207 57.4471 71.1157 57.2262 71.5855 56.9582L80.7461 51.7432L86.2101 54.8548L135 82.6289Z'
      fill='url(#paint2_linear_87_339)'
    />
    <path
      d='M135 4.95678V20.854L80.752 51.7428L71.5914 56.9579C70.3461 57.6675 68.9375 58.0406 67.5043 58.0406C66.071 58.0406 64.6625 57.6675 63.4172 56.9579L54.2566 51.7428L0.00585938 20.854V4.95678C0.00585938 3.64216 0.528085 2.38138 1.45766 1.4518C2.38724 0.522226 3.648 0 4.96262 0H130.049C131.363 0.00164914 132.622 0.524607 133.55 1.45401C134.478 2.3834 135 3.64324 135 4.95678Z'
      fill='url(#paint3_linear_87_339)'
    />
    <g style={{ mixBlendMode: 'multiply' }} opacity='0.2'>
      <path d='M135 20.8545V26.39L86.2164 54.855L80.7524 51.7434L135 20.8545Z' fill='url(#paint4_linear_87_339)' />
      <path
        d='M54.2571 51.7434L48.7931 54.855L0.00634766 26.39V20.8545L54.2571 51.7434Z'
        fill='url(#paint5_linear_87_339)'
      />
    </g>
    <path
      style={{ mixBlendMode: 'multiply' }}
      opacity='0.3'
      d='M86.2162 54.8548L80.7523 58.041L71.5917 63.2561C70.3521 63.9613 68.951 64.3332 67.5248 64.3358H67.4844C66.0582 64.3339 64.6568 63.9619 63.4175 63.2561L54.257 58.041L48.793 54.8548L54.257 51.7432L63.4175 56.9582C63.887 57.2267 64.3821 57.4477 64.8955 57.6179C65.0667 57.6739 65.2347 57.7237 65.4089 57.7703C66.7827 58.1313 68.2265 58.1313 69.6003 57.7703C69.7714 57.7237 69.9425 57.6739 70.1137 57.6179C70.6268 57.4471 71.1219 57.2262 71.5917 56.9582L80.7523 51.7432L86.2162 54.8548Z'
      fill='url(#paint6_linear_87_339)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M63.0973 45.0327L69.8974 44.5572C71.1305 44.471 72.3158 45.0491 73.007 46.0738L76.8189 51.7251C77.5101 52.7499 77.602 54.0655 77.0602 55.1764L74.072 61.3032C73.5301 62.4142 72.4367 63.1517 71.2037 63.2379L64.4036 63.7134C63.1706 63.7996 61.9852 63.2215 61.294 62.1968L57.4822 56.5455C56.791 55.5207 56.699 54.2051 57.2408 53.0942L60.2291 46.9673C60.7709 45.8564 61.8643 45.1189 63.0973 45.0327Z'
      fill='#F87023'
    />
    <defs>
      <linearGradient
        id='paint0_linear_87_339'
        x1='107.876'
        y1='57.5434'
        x2='107.876'
        y2='17.9327'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#FFCF5C' />
        <stop offset='1' stopColor='#FFB300' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_87_339'
        x1='27.1302'
        y1='57.5434'
        x2='27.1302'
        y2='17.9327'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#FFCF5C' />
        <stop offset='1' stopColor='#FFB300' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_87_339'
        x1='67.5031'
        y1='108.216'
        x2='67.5031'
        y2='57.8948'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#FFCF5C' />
        <stop offset='1' stopColor='#FFB52E' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_87_339'
        x1='67.5027'
        y1='25.4249'
        x2='67.5027'
        y2='131.773'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#FFCF5C' />
        <stop offset='1' stopColor='#FFB300' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_87_339'
        x1='107.876'
        y1='69.9525'
        x2='107.876'
        y2='26.2033'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#FFCF5C' />
        <stop offset='1' stopColor='#FFB300' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_87_339'
        x1='27.1302'
        y1='69.9525'
        x2='27.1302'
        y2='26.2033'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#FFCF5C' />
        <stop offset='1' stopColor='#FFB300' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_87_339'
        x1='67.503'
        y1='51.7432'
        x2='67.503'
        y2='64.3389'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#FFCF5C' />
        <stop offset='1' stopColor='#FFB300' />
      </linearGradient>
    </defs>
  </svg>
);

export default EmailSentIcon;
